/**
 * TODO: Need to refactor.
 * This file is copied from `src/pages/courses/components/forum/useForum.js`.
 */
import { useDispatch, useSelector } from 'react-redux';

import * as selectors from '@src/store/selectors';
import * as actionCreators from '@src/store/actions';
import { TSideEffectState } from '@src/types/common';
import { IDiscussion } from '@src/types/course';

interface IUseForum {
	courseId: string;
	onlyMe?: boolean;
}

interface IUseForumReturn {
	discussionsBefore: IDiscussion[];
	discussionsBeforeTotal: number;
	discussions: IDiscussion[];
	courseDiscussionsBeforeState: TSideEffectState;
	courseDiscussionsState: TSideEffectState;
	addCourseDiscussionState: TSideEffectState;
	addCourseDiscussionReplyStates: TSideEffectState;
	handleAddCourseMessage: (
		type: string,
		{ message, unit_id, title }: { message: string; unit_id?: string; title?: string; onSuccess?: () => void }
	) => void;
	handleAddCourseMessageReply: (
		type: string,
		{ commentId, message }: { commentId: string; message: string; onSuccess?: () => void }
	) => void;
	handleAddCourseBeforeMessage: ({ message }: { message: string; onSuccess?: () => void }) => void;
	handleUploadImage: ({ fileData }: { fileData: any }) => void;
	getCourseDiscussionsBefore: ({ pageNumber, pageSize }: { pageNumber: number, pageSize: number }) => void;
}

const useForum = ({ courseId, onlyMe = false }: IUseForum): IUseForumReturn => {
	const dispatch = useDispatch();
	const userId = useSelector(selectors.getUserId);
	let discussionsBefore = useSelector(selectors.getCourseDiscussionsBefore) as IDiscussion[];
	const discussionsBeforeTotal = useSelector(selectors.getCourseDiscussionsBeforeTotal) as number;

	if (onlyMe) {
		discussionsBefore = discussionsBefore.filter(discussion => discussion.user.id === userId);
	}

	let discussions = useSelector(selectors.getCourseDiscussions) as IDiscussion[];
	if (onlyMe) {
		discussions = discussions.filter(discussion => discussion.user.id === userId);
	}

	const courseDiscussionsBeforeState = useSelector(
		selectors.getCourseDiscussionsBeforeState(courseId),
	) as TSideEffectState;

	const courseDiscussionsState = useSelector(
		selectors.getCourseDiscussionsState(courseId),
	) as TSideEffectState;

	const addCourseDiscussionState = useSelector(
		selectors.getAddCourseDiscussionState(courseId),
	) as TSideEffectState;
	const addCourseDiscussionReplyStates = useSelector(
		selectors.getAddCourseDiscussionReplyStates,
	) as TSideEffectState;

	const handleAddCourseMessage = (
		type,
		{ message, unit_id = null, title = null, onSuccess },
	) => {
		const data: {[x: string]: string} = {
			message,
		};

		if (unit_id) {
			data.unit_id = unit_id;
		}

		if (title) {
			data.title = title;
		}

		dispatch(
			actionCreators.addCourseDiscussionCall({
				type,
				course_id: courseId,
				data,
				onSuccess,
			}),
		);
	};

	const handleAddCourseMessageReply = (type, { commentId, message, onSuccess }) => {
		dispatch(
			actionCreators.addCourseDiscussionReplyCall({
				type,
				course_id: courseId,
				comment_id: commentId,
				data: { message },
				onSuccess,
			}),
		);
	};

	const handleAddCourseBeforeMessage = ({ message, onSuccess }) => {
		dispatch(
			actionCreators.addCourseDiscussionsBeforeCall({
				course_id: courseId,
				data: { message },
				onSuccess,
			}),
		);
	};

	const handleUploadImage = ({ fileData }) => {
		dispatch(actionCreators.uploadCall({ fileData }));
	};

	const getCourseDiscussionsBefore = ({ pageNumber, pageSize }) => {
		dispatch(
			actionCreators.getCourseDiscussionsBeforeCall({
				course_id: courseId,
				page: pageNumber,
				pageSize,
			}),
		);
	};

	return {
		courseDiscussionsBeforeState,
		courseDiscussionsState,
		discussionsBefore,
		discussionsBeforeTotal,
		discussions,
		addCourseDiscussionState,
		addCourseDiscussionReplyStates,
		handleAddCourseMessage,
		handleAddCourseMessageReply,
		handleAddCourseBeforeMessage,
		handleUploadImage,
		getCourseDiscussionsBefore,
	};
};

export default useForum;
